// @flow strict

import * as React from 'react';

import type {
  SectionsItem,
  STEP_QUESTIONNAIRE_SECTIONS_RESPONSE,
  FEEDBACK_CONFIG_RESPONSE,
  Review,
  JobStageStep,
} from 'src/types/crm';

import EvaluationSubjectiveQuestionsView from './evaluation-subjective-questions-view.jsx';


const EvaluationFormView = ({
  scorecardStepSections,
  subjectiveSections,
  feedbackConfiguration,
  review,
  step,
  token,
  tokenId,
  forPdf = false,
}: {
  scorecardStepSections: Array<{
    ...SectionsItem,
    status: string,
  }>,
  subjectiveSections: Array<STEP_QUESTIONNAIRE_SECTIONS_RESPONSE>,
  feedbackConfiguration: FEEDBACK_CONFIG_RESPONSE,
  review: Review,
  step: JobStageStep,
  token?: string,
  tokenId?: string,
}): React.Node => {
  const {reviewStatus, comment, feedbackScores} = review;

  const answers = (review.answers || []).reduce((acc, item) => {
    acc[item.questionId] = item.answer;
    return acc;
  }, {});

  const hideScorecard = step.hideScorecard;

  return (
    <>
      <EvaluationSubjectiveQuestionsView
        subjectiveSections={subjectiveSections}
        answers={answers}
        token={token}
        tokenId={tokenId}
        review={review}
        comment={comment}
        feedbackConfiguration={feedbackConfiguration}
        reviewStatus={reviewStatus}
        scorecardStepSections={scorecardStepSections}
        feedbackScores={feedbackScores}
        hideScorecard={hideScorecard}
        step={step}
        forPdf={forPdf}
      />
    </>
  );
};

export default EvaluationFormView;
